import { ActionTrigger, ActionType } from '@maximizer/actions/domain';
import { ActionTypeMeta } from '../models/action-card.model';

export const ACTION_TYPE_META: Readonly<Record<ActionType, ActionTypeMeta>> = {
  email: {
    labelKey: 'actionsInbox.type.email',
    icon: 'envelope',
    external: true,
    verbKey: 'actionsInbox.verb.sendEmail',
    verbIcon: 'paper-plane',
    declineKey: 'actionsInbox.decline.dontSend',
  },
  email_batch: {
    labelKey: 'actionsInbox.type.emailBatch',
    icon: 'envelopes-bulk',
    external: true,
    verbKey: 'actionsInbox.verb.sendEmails',
    verbOneKey: 'actionsInbox.verb.sendEmailsOne',
    verbCountKey: 'actionsInbox.verb.sendEmailsCount',
    verbIcon: 'paper-plane',
    declineKey: 'actionsInbox.decline.dontSend',
  },
  form: {
    labelKey: 'actionsInbox.type.form',
    icon: 'file-lines',
    external: false,
    verbKey: 'actionsInbox.verb.saveToTimeline',
    verbIcon: 'clock-rotate-left',
    declineKey: 'actionsInbox.decline.discardDraft',
  },
  crm_update: {
    labelKey: 'actionsInbox.type.crmUpdate',
    icon: 'arrow-right-arrow-left',
    external: false,
    verbKey: 'actionsInbox.verb.applyChanges',
    verbOneKey: 'actionsInbox.verb.applyChangesOne',
    verbCountKey: 'actionsInbox.verb.applyChangesCount',
    verbIcon: 'check',
    declineKey: 'actionsInbox.decline.rejectAll',
    explicitDecisions: true,
  },
  brief: {
    labelKey: 'actionsInbox.type.brief',
    icon: 'list-check',
    external: false,
    verbKey: 'actionsInbox.verb.markAsRead',
    verbIcon: 'check',
    declineKey: 'actionsInbox.decline.dismiss',
    acknowledgeOnly: true,
  },
  appointment: {
    labelKey: 'actionsInbox.type.appointment',
    icon: 'calendar',
    external: false,
    verbKey: 'actionsInbox.verb.createAppointment',
    verbIcon: 'calendar-plus',
    declineKey: 'actionsInbox.decline.dismiss',
  },
};

const UNKNOWN_TYPE_META: ActionTypeMeta = {
  labelKey: 'actionsInbox.type.unknown',
  icon: 'circle-question',
  external: false,
  verbKey: 'actionsInbox.verb.acknowledge',
  verbIcon: 'check',
  declineKey: 'actionsInbox.decline.reject',
};

export function actionTypeMeta(type: string): ActionTypeMeta {
  return (
    (ACTION_TYPE_META as Record<string, ActionTypeMeta | undefined>)[type] ??
    UNKNOWN_TYPE_META
  );
}

export const ACTION_TRIGGER_ICON: Readonly<Record<ActionTrigger, string>> = {
  manual: 'hand-pointer',
  event: 'bolt-auto',
  schedule: 'clock',
  recipe: 'arrows-rotate',
  iq_boost: 'wand-magic-sparkles',
};
